/** sessionStorage key for optional referrer username (set from ?ref= on register). */
export const REFERRER_USERNAME_STORAGE_KEY = 'prdiktit_referrer_username';
